<template>
  <div class="SetupStepsSidebar d-flex" :class="{ cssDisplayStyles }">
    <Sidebar
      v-model="toggle"
      :class="{ loading }"
      :steps="steps"
      :active-step="active"
      :errors="errorIndexes"
      @select="(index) => (selected = index)"
      @click-on-el="$emit('click-on-section')"
      @click.native="hideSidebar"
    >
      <template
        v-for="(_, name) in $scopedSlots"
        slot-scope="slotData"
        :slot="name"
        v-if="name"
      >
        <slot :name="name" v-bind="slotData" />
      </template>

      <template #below-sections>
        <slot v-if="toggle" name="below-sections"></slot>
      </template>
    </Sidebar>
    <div class="mobile-placeholder-sidebar"></div>

    <transition name="fade-trans">
      <div v-if="toggle && !isDesktop" class="dark-background"></div>
    </transition>

    <div class="slots-content d-flex flex-column">
      <div class="d-flex content-wrapper" ref="content-wrapper">
        <slot :active="active" ref="content"></slot>
      </div>

      <span class="d-flex justify-content-between pt-0 pl-4 pr-4 pb-4">
        <span></span>

        <button
          v-if="!removeSaveButton"
          type="button"
          class="btn btn-primary"
          id="setup-next"
          @click="goNext"
        >
          <slot name="last-step-save"> Opslaan </slot>
        </button>
      </span>
    </div>
  </div>
</template>

<script>
import Sidebar from "./Sidebar/Sidebar.vue";
import params from "/src/mixins/table";

export default {
  mixins: [
    params({
      params: {
        section: null,
      },
    }),
  ],
  components: {
    Sidebar,
  },
  props: {
    ignoreClass: String,
    diselectAll: Boolean,
    cssDisplayStyles: {
      type: Boolean,
      default: true,
    },
    steps: {
      type: Array,
      required: true,
    },

    querySelector: String,
    removeSaveButton: Boolean,
    loading: Boolean,
    modal: Boolean,
    isEditing: [Boolean, String],
  },
  data() {
    return {
      selected: 0,
      alreadyCompletedIndex: 0,
      errorIndexes: [],
      toggle: false,
      isDesktop: false,
    };
  },
  created() {
    if (this.section === 'content') {
      this.section = ''
    } else {
      const section = this.section
      if (section) this.goToSection(section)
    }

    if (window.screen.width > 640) {
      this.toggle = true;
      this.isDesktop = true;
    }
  },
  mounted() {
    this.updateSelectedComponentVisibility();
  },
  methods: {
    hideSidebar() {
      if (!this.isDesktop) this.toggle = false;
    },
    setErrorIndex(index) {
      if (!this.errorIndexes.includes(index)) {
        this.errorIndexes.push(index);
      }
    },
    removeIndexError(index) {
      const errorIndex = this.errorIndexes.indexOf(index);
      if (errorIndex > -1) this.errorIndexes.splice(errorIndex, 1);
    },
    hasError() {
      const errorIndexes = [];
      this.validationCheckers.forEach((checker, index) => {
        if (checker()) {
          errorIndexes.push(index);
        }
      });
      this.errorIndexes = errorIndexes;

      if (errorIndexes.length) {
        this.$error("Corrigeer alle formulierfouten voordat u verdergaat!");
      }
      return errorIndexes.length > 0;
    },
    goNext(saveForm = true) {
      if (this.isLastStep || this.isEditing) {
        saveForm && this.saveForm();
        return false;
      } else {
        this.selected++;
        return true;
      }
    },
    saveForm() {
      if (this.hasError()) return;
      this.$emit("save-form");
    },
    goToSection(section) {
      const index = this.steps.findIndex((step) => step.id === section);
      if (index > -1) this.selected = index;
      else this.$emit("didnt-find-active-section", section);
    },
    _removeIndexError(errorFunctionChecker) {
      const sidebarIndex = this.validationCheckers.findIndex(
        (checker) => checker === errorFunctionChecker
      );
      if (sidebarIndex > -1) {
        this.removeIndexError(sidebarIndex);
      }
    },
    updateSelectedComponentVisibility() {
      const activeIndex = this.selected;
      const query = this.querySelector;

      [
        ...(query
          ? document.querySelector(query).children
          : this.$refs["content-wrapper"].children),
      ].forEach((item, index) => {
        if (this.ignoreClass && item.classList.contains(this.ignoreClass))
          return;

        if (activeIndex === index) {
          item.style.display = "block";
        } else {
          item.style.display = "none";
        }
      });
    },
  },
  computed: {
    isLastStep() {
      return this.selected === this.steps.length - 1;
    },
    active() {
      return this.steps[this.selected] && this.steps[this.selected].id;
    },
  },
  watch: {
    diselectAll(val) {
      if (val) {
        this.selected = null;
      }
    },
    selected(index) {
      this.updateSelectedComponentVisibility();
      this.$emit("selected", index);
    },
    active(val) {
      this.$emit("active", val);
      if (!this.modal && val) this.section = val;
    },
    alreadyCompletedIndex(index) {
      this.selected = null;
      this.$emit("next", index);
    },
  },
};
</script>

<style scoped>
.mobile-placeholder-sidebar {
  width: 36px;
  max-width: 36px;
  flex-shrink: 0;
}

.mobile-placeholder-sidebar {
  display: none;
}

@media (min-width: 639px) {
  .mobile-placeholder-sidebar {
    display: none;
  }
}

.dark-background {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 35;
  background-color: rgba(0, 0, 0, 0.1);
}

.SetupStepsSidebar {
  flex-grow: 1;
  width: 100%;
  flex-basis: 100%;
}

@media (min-width: 641px) {
  .SetupStepsSidebar {
    flex-wrap: nowrap !important;
  }
}

.SetupStepsSidebar .loading {
  opacity: 0.6;
  pointer-events: none;
}

.SetupStepsSidebar > div {
  flex-grow: 1;
}

@media (max-width: 640px){
  .SetupStepsSidebar > div{
    flex: 100%;
  }
}

.slots-content > div,
.content-wrapper > div {
  flex-grow: 1;
  flex-basis: 100%;
  overflow: auto;
}

.cssDisplayStyles .content-wrapper > div {
  width: 100%;
  display: none;
}

.website-contents {
  overflow: auto;
}

@media (max-width: 768px) {
  .SetupStepsSidebar {
    display: -webkit-box !important;
    flex-wrap: wrap;
  }
}
</style>
